<template>
<!-- 广告发布-价格设置 -->
  <div>
    <the-nav-bar :title="$t('createPost.customizePrice')" />
    <div class="body-wrapper">

      <md-tabs v-model="currentTab" class="tabs">
        <md-tab-pane
          class="tab-content"
          name="fixed"
          :label="$t('customize.fixedPrice')"
        >
          <div class="col fixed-panel">
            <md-input-item
              v-model="fixedPrice"
              v-input-mode="'decimal'"
              type="number"
              class="input-item"
              placeholder="Hi,TIGA"
              :readonly="isSubmitting"
               @change="onfixdPriceChange"
            ></md-input-item>

            <p v-if="preferencePrice !=0" class="strong text">
              {{ $t('customize.referencePrice') }} {{ preferencePrice }}
            </p>
            <p v-else class="strong text">
              {{ $t('customize.referencePrice') }} 暂不支持该精度位数
            </p>
            <p class="text">
              {{
                $t('customize.referenceText', {
                  symbol: symbol,
                  unit: unit,
                  buyPrice: buyPrice,
                  sellPrice: sellPrice,
                })
              }}
            </p>
            <md-button
              :type="isFixedBtnDisabled ? 'disabled' : 'primary'"
              class="btn"
              @click="onfixedBtnClick"
            >
              <span>{{ $t('common.confirm') }}</span>
            </md-button>
          </div>
        </md-tab-pane>
        <md-tab-pane
          class="tab-content"
          name="dynamic"
          :label="$t('customize.dynamicPrice')"
          disabled
        >
          <div class="col dynamic-panel">
            <div class="panel-header">
              <p class="strong text">
                {{ $t('customize.dynamicPriceText[0]') }}
              </p>
              <p class="text">{{ $t('customize.dynamicPriceText[1]') }}</p>
            </div>
            <div class="panel-body field">
              <div
                class="field-item row-justify-center"
                @click="showPopup('reference')"
              >
                <div class="field-item-title">
                  {{ $t('customize.dynamicReference') }}
                </div>
                <div
                  class="field-item-content"
                  :class="{ inactive: reference === '' }"
                >
                  {{
                    (referenceList[reference] &&
                      referenceList[reference].text) ||
                      $t('createPost.default')
                  }}
                </div>
                <div class="field-item-right">
                  <md-icon
                    name="arrow-right"
                    size="sm"
                    color="#84969C"
                  ></md-icon>
                </div>
              </div>
              <div
                class="field-item row-justify-center"
                @click="showPopup('above')"
              >
                <div class="field-item-title">
                  {{ $t('customize.dynamicAboveOrBelow') }}
                </div>
                <div
                  class="field-item-content"
                  :class="{ inactive: isAbove === '' }"
                >
                  {{
                    (aboveList[isAbove] && aboveList[isAbove].text) ||
                      $t('createPost.default')
                  }}
                </div>
                <div class="field-item-right">
                  <md-icon
                    name="arrow-right"
                    size="sm"
                    color="#84969C"
                  ></md-icon>
                </div>
              </div>
              <div
                class="field-item row-justify-center"
                v-if="exinoneReferenceId != reference" 
              > <!-- 如不是参考exinone价 则用百分比形式 -->
                <div class="field-item-title">
                  {{ $t('customize.percentage') }}
                </div>
                <div class="field-item-content">
                  <md-input-item
                    v-model="percent"
                    v-input-mode="'decimal'"
                    type="number"
                    class="input-item"
                    align="right"
                    @change="onPercentChange"
                  >
                    <div class="unit" slot="right">%</div>
                  </md-input-item>
                </div>
              </div>
              <div class="field-item row-justify-center" v-else>
                <div class="field-item-title">
                  {{ $t('customize.difference') }}
                </div>
                <div class="field-item-content">
                  <md-input-item
                    v-model="difference"
                    v-input-mode="'decimal'"
                    type="number"
                    class="input-item"
                    align="right"
                    @change="onDifferenceChange"
                  >
                    <div class="unit" slot="right">{{ unit }}</div>
                  </md-input-item>
                </div>
              </div>
              <div class="field-item row-justify-center">
                <div class="field-item-title">
                  {{ $t('customize.lowestPrice') }}
                </div>
                <div class="field-item-content">
                  <md-input-item
                    v-model="lowestPrice"
                    v-input-mode="'decimal'"
                    type="number"
                    class="input-item"
                    align="right"
                  >
                    <div class="unit" slot="right">{{ unit }}</div>
                  </md-input-item>
                </div>
              </div>
            </div>
            <div class="panel-footer">
              <p class="text">
                {{
                  $t('customize.referenceText', {
                    symbol: symbol,
                    unit: unit,
                    buyPrice: buyPrice,
                    sellPrice: sellPrice,
                  })
                }}
              </p>
              <p class="text" style="color:red;">
                {{$t('customize.dynamicPriceNotice')}}
              </p>
              <md-button
                :type="isDynamicBtnDisabled ? 'disabled' : 'primary'"
                class="btn"
                @click="onDynamicBtnClick"
              >
                <span>{{ $t('common.confirm') }}</span>
              </md-button>
            </div>
          </div>
        </md-tab-pane>
      </md-tabs>
    </div>
    <md-popup v-model="isShowPopup" position="bottom" class="popup">
      <md-popup-title-bar
        only-close
        large-radius
        class="title-bar"
        :title="popupData.title"
        @confirm="hidePopup"
        @cancel="hidePopup"
      />
      <md-scroll-view :scrolling-x="false" auto-reflow class="popup-body">
        <div
          class="popup-item row-center"
          v-for="(item, index) in popupData.list"
          :key="`popup-item-${popupData.name}-${index}`"
          @click="onChoose(index)"
          :class="{ active: index === popupData.value }"
        >
          <div class="text">{{ item.text }}</div>
        </div>
      </md-scroll-view>
    </md-popup>
  </div>
</template>

<script>
import TheNavBar from '@/components/the-nav-bar';
import {
  Tabs,
  TabPane,
  InputItem,
  Button,
  Icon,
  Popup,
  PopupTitleBar,
  ScrollView,
  Toast,
  Dialog,
} from 'mand-mobile';
import { mapState } from 'vuex';
import getCurrentPrice from '@/api/get-current-price';
import toFixed from '@/utils/to-fixed';
export default {
  components: {
    'the-nav-bar': TheNavBar,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [InputItem.name]: InputItem,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Popup.name]: Popup,
    [PopupTitleBar.name]: PopupTitleBar,
    [ScrollView.name]: ScrollView,
    [Dialog.name]: Dialog,
  },
  data() {
    return {
      fiatCurrencyId: '', // 法币ID
      cryptoId: '', // 加密货币ID
      currentTab: 'fixed', // 固定价格 or 浮动价格  @byron 这里是发布广告的设置页面
      fixedPrice: '',
      preferencePrice: '',
      exinBuyPrice: 0,
      exinSellPrice: 0,
      reference: '', //参考对象
      isAbove: '', // 高于还是低于
      percent: '', // 百分比
      difference: '', // 价差
      lowestPrice: '', // 最低价
      isSubmitting: false,
      isShowPopup: false,
      popupData: {
        name: '',
        title: '',
        value: '',
        list: [],
      },
      pollKey: null,
      pollInterval: 3000,
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      settings: state => state.settings,
      adTemp: state => state.adTemp,
      legalCurrencyList: state => state.settings.legalCurrencyList,
      cryptoList: state => state.settings.cryptoList,
      exinoneReferenceId: state => state.settings.exinoneReferenceId,
      advertisementRate(state) {
        return (
          state.userInfo.advertisementRate ||
          state.settings.rate.advertisementRate
        );
      },
    }),
    config() {
      const {
        cryptoId,
        fiatCurrencyId,
        cryptoList,
        legalCurrencyList,
        adTemp,
      } = this;
      const asset = cryptoList.find(item => item.id == cryptoId);
      const currency = legalCurrencyList.find(
        item => item.id == fiatCurrencyId,
      );
      return {
        exinSupported:
          asset && asset.exinSupported && currency && currency.unit == 'CNY',
        decimalDigit: //这个是数字币精度，这里以前用作法币的精度，弃用
          adTemp.attribute == '1' &&//群广告类型
          [
            '4d8c508b-91c5-375b-92b0-ee702ed2dac5', //usdt
            '31d2ea9c-95eb-3355-b65b-ba096853bc18', //pusd
            'b91e18ff-a9ae-3dc7-8679-e935d9a4b34b', //usdt-trc
            '815b0b1a-2764-3736-8faa-42d694fa620a', //usdt
            '5dac5e28-ad13-31ea-869f-41770dfcee09',//usdt
          ].includes(asset && asset.uuid)
            ? 3
            : asset && asset.exinDecimalDigit,//判断群广告，弃用，变更为在群广告
        currency,
      };
    },
    referenceList(state) {//参考价格来源选择列表
      return state.settings.referenceList //写死在store/settings里了 0 即avg 
        .map(item => {
          if (item.id == this.exinoneReferenceId) {//exinone在array下标为1
            return Object.assign({}, item, {
              text: this.$t('customize.exinone'),//纯粹中英文需要
            });
          } else {
            return Object.assign({}, item);
          }
        })
        .filter(item => {
          if (item.id == this.exinoneReferenceId) {
            return this.config.exinSupported;//如果支持，则显示
          }
          return true;//默认都显示
        });
    },
    isFixedBtnDisabled() {
      return !this.fixedPrice || isNaN(this.fixedPrice) || this.isSubmitting;
    },
    isDynamicBtnDisabled() {
      return (
        (this.percent === '' && this.reference !== this.exinoneReferenceId) ||
        (this.reference === this.exinoneReferenceId &&
          this.difference === '') ||
        isNaN(this.percent) ||
        this.isSubmitting ||
        this.reference === '' ||
        this.isAbove === ''
      );
    },
    aboveList() {
      return [
        {
          value: 0,
          text: this.$t('customize.below'),
        },
        {
          value: 1,
          text: this.$t('customize.above'),
        },
      ];
    },
    unit() {
      const obj = this.legalCurrencyList.find(item => {
        return item.id === this.fiatCurrencyId;
      });
      return (obj && obj.unit) || '';
    },
    symbol() {
      const obj = this.cryptoList.find(item => {
        return item.id === this.cryptoId;
      });
      return (obj && obj.symbol) || '';
    },
    sellPrice() {//1单位数字币的场外币价格
      const advertisementRate = +this.advertisementRate;
      if (this.currentTab === 'fixed') {//固定价
        const price = +this.fixedPrice;
        var _decimal = 8;
        if (typeof this.config.currency!== 'undefined') {
          _decimal = this.config.currency.decimal ; 
        }
        return toFixed(price * (1 - advertisementRate / 100), _decimal).replace(/\.?0+$/, '');
      } else {
        if (this.isAbove === '' || this.reference === '') {
          return this.preferencePrice;//mixin主网价格 即mixin主网提供的usdt价格*汇率
        }
        if (
          this.referenceList[this.reference] &&
          this.referenceList[this.reference].value === 'exinone'
        ) {
          let output = (1 - advertisementRate / 100) * +this.exinSellPrice;//exinone cny价格
          if (this.isAbove) {
            return toFixed(
              output + Number(this.difference),
              this.config.decimalDigit,
            );
          } else {
            return toFixed(
              output - Number(this.difference),
              this.config.decimalDigit,
            );
          }
        } else {
          const percent = +this.percent;
          let rate;
          if (this.isAbove) {
            rate = 1 + percent / 100;
          } else {
            rate = 1 - percent / 100;
          }
          return toFixed(
            rate * (1 - advertisementRate / 100) * +this.preferencePrice,
            this.config.currency.decimal, //小数位
          );
        }
      }
    },
    buyPrice() {//底部显示的价格提示
      const advertisementRate = +this.advertisementRate;
      if (this.currentTab == 'fixed') {
        const price = +this.fixedPrice;
        var _decimal = 8;
        if (typeof this.config.currency !== 'undefined') {
          _decimal = this.config.currency.decimal ; 
        }
        return toFixed(price * (1 + advertisementRate / 100), _decimal).replace(/\.?0+$/, '');
      } else {
        if (this.isAbove === '' || this.reference === '') {//默认
          return this.preferencePrice;
        }
        if (
          this.referenceList[this.reference] &&
          this.referenceList[this.reference].value === 'exinone'
        ) {
          let output = (1 - advertisementRate / 100) * +this.exinBuyPrice;
          if (this.isAbove) {//设置高于价差
            return toFixed(
              output + Number(this.difference),
              this.config.decimalDigit,
            );
          } else {
            return toFixed(
              output - Number(this.difference),
              this.config.decimalDigit,
            );
          }
        } else {//其他则按百分比
          const percent = +this.percent;
          let rate;
          if (this.isAbove) {
            rate = 1 + percent / 100;
          } else {
            rate = 1 - percent / 100;
          }
          return toFixed(
            rate * (1 + advertisementRate / 100) * +this.preferencePrice,
            this.config.currency.decimal, //小数位
          );
        }
      }
    },
  },
  mounted() {
    const query = this.$route.query;
    if (
      !query.fiatCurrencyId ||
      !query.cryptoId ||
      !this.settings.isSettingsLoaded
    ) {
      Toast.failed(`${this.$t('error.occur')} ${this.$t('error.para')}`);
      return this.$router.replace('/exchange');
    }
    this.fiatCurrencyId = query.fiatCurrencyId;
    this.cryptoId = query.cryptoId;
    // 上一次保存的数据
    const {
      isFixed,
      fixedPrice,
      reference,
      isAbove,
      percentage,
      difference,
      lowestPrice,
    } = this.adTemp;
    this.currentTab = isFixed ? 'fixed':'fixed' ;  //暂时禁止dynamic ，默认固定价格  dynamic
    this.fixedPrice = fixedPrice;
    if (reference !== '') {
      this.reference = reference;
    } else {
      if (this.config.exinSupported) {
        this.reference = this.referenceList.findIndex(
          item => item.id == this.exinoneReferenceId,
        );
      }
    }
    this.isAbove = isAbove;
    this.percent = percentage;
    this.difference = difference;
    this.lowestPrice = lowestPrice;
    // 轮询参考价格
    Toast.loading(this.$t('common.loading'));
    const p1 = this.loadReferencePrice();
    const p2 = this.$store.dispatch('updateUserInfo');
    Promise.all([p1, p2])
      .then(() => {
        Toast.hide();
      })
      .catch(err => {
        Toast.failed(`${this.$t('error.occur')}${err.message}`);
      });
    this.pollKey = setInterval(this.loadReferencePrice, this.pollInterval);
  },
  beforeDestroy() {
    clearInterval(this.pollKey);
  },
  methods: {
    //固定价格确认按钮点击
    onfixedBtnClick() {
      this.isSubmitting = true;
      if(this.fixedPrice == 0){
        Toast.failed('价格不能为0');
        this.isSubmitting = false;
        return;
      }
      if(this.preferencePrice && this.preferencePrice > 0){
        if(Math.abs(this.fixedPrice - this.preferencePrice)/this.preferencePrice > 0.1){
          return Dialog.confirm({
            title: '价格异常!',
            content: '当前设置的固定价格偏离参考价格超过10%，请确认。',
            cancelText: this.$t('common.cancel'),
            confirmText: this.$t('common.confirm'),
            onConfirm: () => {
              this.onfixedBtnClickConfirmed();
            },
            onCancel: ()=> {
              this.isSubmitting = false;
            },
          });
        }
      }

      this.onfixedBtnClickConfirmed();

    },
    //固定价格最终确认后
    onfixedBtnClickConfirmed(){
      const obj = {
        isFixed: true,
        fixedPrice: this.fixedPrice,
        isAbove: '',
        reference: '',
        percent: '',
      };
      this.$store.commit('setCreateTemp', obj);
      this.$nextTick(() => {
        this.isSubmitting = false;
        this.$router.back();
      });
    },
    onDynamicBtnClick() {
      this.isSubmitting = true;
      const obj = {
        isFixed: false, 
        fixedPrice: '',
        isAbove: this.isAbove,
        reference: this.reference,
        percentage: this.percent,
        difference: this.difference,
        lowestPrice: this.lowestPrice,
      };
      this.$store.commit('setCreateTemp', obj);
      this.$nextTick(() => {
        this.isSubmitting = false;
        this.$router.back();
      });
    },
    onPercentChange() {
      if (this.percent < 0) {
        this.percent = 0;
      }
      if (this.percent >= 100) {
        this.percent = 99.99;
      }
      this.$nextTick(() => {
        this.percent = this.fixDecimal(this.percent, 2);
      });
    },
    onDifferenceChange() {
      this.$nextTick(() => {
        if (this.difference === '') {
          return;
        }
        if (this.difference < 0) {
          this.difference = 0;
          return;
        }
        let output = this.fixDecimal(this.difference, this.config.decimalDigit);
        while (output[0] === '0' && output[1] && output[1] !== '.') {
          output = output.slice(1);
        }
        this.difference = output;
      });
    },
    onfixdPriceChange() {//固定价格  输入
      this.$nextTick(() => {
        if (this.fixedPrice === '') {
          return;
        }
        if (this.fixedPrice < 0) {
          this.difference = 0;
          return;
        }
        //这里可以考虑如果是群广告，给usdt加一位小数位
        // this.adTemp.attribute == '1' &&//群广告类型
        // [
        //   '4d8c508b-91c5-375b-92b0-ee702ed2dac5', //usdt
        //   '31d2ea9c-95eb-3355-b65b-ba096853bc18', //pusd
        //   'b91e18ff-a9ae-3dc7-8679-e935d9a4b34b', //usdt-trc
        //   '815b0b1a-2764-3736-8faa-42d694fa620a', //usdt
        //   '5dac5e28-ad13-31ea-869f-41770dfcee09',//usdt
        // ].includes(asset && asset.uuid);
        let output = this.fixDecimal(this.fixedPrice, this.config.currency.decimal); //小数位legal_currencies
        while (output[0] === '0' && output[1] && output[1] !== '.') {
          output = output.slice(1);
        }
        this.fixedPrice = output;
      });
    },
    showPopup(name) {
      if (name == 'reference') {
        this.popupData.title = this.$t('customize.dynamicReference');
        this.popupData.value = this.reference;
      }
      if (name == 'above') {
        this.popupData.title = this.$t('customize.dynamicAboveOrBelow');
        this.popupData.value = this.isAbove;
      }
      this.popupData.name = name;
      this.popupData.list = this[`${name}List`];
      this.$nextTick(() => {
        this.isShowPopup = true;
      });
    },
    hidePopup() {
      this.isShowPopup = false;
    },
    onChoose(index) {
      this.popupData.value = index;
      if (this.popupData.name == 'reference') {
        this.reference = index;
      }
      if (this.popupData.name == 'above') {
        this.isAbove = index;
      }
      this.hidePopup();
    },
    loadReferencePrice() {
      return getCurrentPrice(this.cryptoId, this.fiatCurrencyId).then(data => {
        this.preferencePrice = data.data.price;
        this.exinBuyPrice = data.data.exin_buy_price || 0;
        this.exinSellPrice = data.data.exin_sell_price || 0;
      });
    },
    //截掉小数点后指定位数的值
    fixDecimal(num, decimal) {
      let sumArr = num.toString().split('.');
      if (sumArr[1] !== undefined && sumArr[1].length > decimal) {
        sumArr[1] = sumArr[1].slice(0, decimal);
        if (sumArr[1]) {
          return sumArr.join('.');
        } else {
          return sumArr[0];
        }
      } else {
        return num;
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.body-wrapper {
  padding: 6.4vw 0 30vw;

  >>> .md-tab-bar-item {
    flex: 0 0 50vw;
  }
}

.fixed-panel {
  margin: 9.6vw 4.8vw 4.8vw;

  .input-item {
    background: #f8f8fc;
    padding: 0 2.13vw;
    border: 0.27vw solid #eaf1f3;
    border-radius: 2.67vw;

    >>> .md-field-item-content:before {
      content: none;
    }
  }

  .text {
    margin-top: 4.8vw;
    color: #84969c;

    &.strong {
      color: #CE5849;
    }
  }

  .btn {
    margin-top: 9.6vw;
  }
}

.dynamic-panel {
  padding-top: 9.6vw;

  .panel-header {
    margin: 0 4.8vw;

    .text {
      margin-bottom: 4.8vw;
      font-size: 3.2vw;
    }

    .strong {
      font-size: 3.73vw;
    }
  }

  .panel-body {
    .field-item {
      height: 17.07vw;
      padding: 0 4.8vw;
      font-size: 3.73vw;

      &:nth-child(even) {
        background: #f8fBfc;
      }
    }

    .field-item-title {
      flex: 0 0 32vw;
      font-weight: bold;
    }

    .field-item-content {
      flex: 1 0 0;
      text-align: right;
      color: color-primary;

      &.inactive {
        color: #BCC7CB;
      }
    }

    .field-item-right {
      margin-left: 1.07vw;
    }

    .input-item {
      padding: 0 2.13vw;
      border: 0.27vw solid #EAF1F3;
      border-radius: 2.67vw;
      background: #F8FBFC;

      >>> .md-field-item-content:before {
        content: none;
      }

      .unit {
        margin-left: 4.8vw;
        font-size: 3.73vw;
        color: #1b6fdc;
      }
    }
  }

  .panel-footer {
    margin: 0 4.8vw;

    .text {
      margin-top: 4.8vw;
    }

    .btn {
      margin-top: 9.6vw;
    }
  }
}

.popup {
  .title-bar {
    border-bottom: 0.27vw solid #eaf1f3;

    >>> .title-bar-left, >>> .title-bar-right {
      width: 30%;
    }
  }

  .popup-body {
    padding-bottom: 10vw;
    height: auto;
    min-height: 60vw;
    max-height: 80vw;
    overflow-y: auto;
    background: #fff;
  }

  .popup-item {
    height: 12.8vw;
    margin: 0 6.4vw;
    font-size: 4.27vw;

    &.active {
      color: color-primary;
    }
  }
}
</style>
